import { apiFetch } from '@/shared/api/client'
import { isMockApi } from '@/shared/env'
import { clearDelmanSession } from '@/shared/auth/delmanSessionStorage'
import type { KitchenSession } from '@/shared/auth/sessionStorage'

type PinLoginRequest = {
  device_id: string
  pin: string
}

type PinLoginResponse = {
  access_token: string
  user: {
    id: string
    name: string
    role: 'HEAD_KITCHEN' | 'STAFF_KITCHEN'
  }
}

const DEV_PIN = '123456'

function useMockApi(): boolean {
  return isMockApi
}

function mapToSession(payload: PinLoginResponse): KitchenSession {
  return {
    accessToken: payload.access_token,
    userId: payload.user.id,
    userName: payload.user.name,
    role: payload.user.role,
    loggedInAt: new Date().toISOString(),
  }
}

function mockPinLogin(req: PinLoginRequest): KitchenSession {
  if (req.pin !== DEV_PIN) {
    throw new Error('PIN salah. Coba lagi atau hubungi Admin HO jika lupa PIN.')
  }
  clearDelmanSession()

  return {
    accessToken: `mock-token-${req.device_id}`,
    userId: 'user-kitchen-1',
    userName: 'Kepala Dapur A',
    role: 'HEAD_KITCHEN',
    loggedInAt: new Date().toISOString(),
  }
}

export async function loginKitchenPin(req: PinLoginRequest): Promise<KitchenSession> {
  if (useMockApi()) {
    await new Promise((resolve) => setTimeout(resolve, 450))
    return mockPinLogin(req)
  }

  const payload = await apiFetch<PinLoginResponse>('/auth/pin-login', {
    method: 'POST',
    body: JSON.stringify(req),
  })
  clearDelmanSession()
  return mapToSession(payload)
}
